import DriverPlanEntryCheckoutEventUpdateRequest from "../../../../../api/raily/driver/plan-entry/checkout-event/update/driver-plan-entry-checkout-event-update.request";
import DriverPlanEntryCheckoutEventUpdateParams from "./driver-plan-entry-checkout-event-update-params";

const create = (
  params: DriverPlanEntryCheckoutEventUpdateParams,
): DriverPlanEntryCheckoutEventUpdateRequest => {
  return {
    checkoutEventUuid: params.checkoutEventUuid,
    driverUuid: params.driverUuid,
    newHaltingTime: params.newHaltingTime,
    newHighwayCharge: params.newHighwayCharge,
    planEntryUuid: params.planEntryUuid,
  };
};

const driverPlanEntryCheckoutEventUpdateParamsFactory = {
  create,
};

export default driverPlanEntryCheckoutEventUpdateParamsFactory;
